import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M19.8788 8.03033L1.07206 8.03033", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M7.75891 1.34351L1.07204 8.03037L7.75891 14.7172", stroke: "currentColor", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
